import {withProps} from 'recompose';
import omit from 'lodash/omit';

export default withProps(({fieldMetadata, hasPartsOnSite}) => ({
  fieldMetadata:
    hasPartsOnSite !== 'Yes'
      ? omit(fieldMetadata, ['PartsOnSiteDescription'])
      : fieldMetadata
}));
